export * from './lab-pathology.service';